module.exports = __webpack_public_path__ + "static/media/IMG-5.914c8c95.jpg";